<template>
    <div
        v-if="hasNotification"
        :class="{
            'gst-notification-container-mobile': $vuetify.display.smAndDown,
        }"
        class="gst-notification-container">
        <transition-group
            name="fade"
            tag="div"
            appear>
            <component
                :is="componentForItem(item)"
                v-for="item in items"
                :key="item.uid"
                :item="item" />
        </transition-group>
    </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import NotificationContainerCard from './NotificationContainerCard';

export default {
    name: 'NotificationContainer',
    computed: {
        ...mapState(['notification']),
        ...mapGetters({
            hasNotification: 'notification/hasNotification',
        }),
        items() {
            return this.notification.items.filter((item) => item.show);
        },
    },
    methods: {
        ...mapActions({
            close: 'notification/close',
        }),
        componentForItem(item) {
            return item.component ? item.component : NotificationContainerCard;
        },
    },
};
</script>
<style lang="scss">
@import '@scssVariables';

$error: theme-color('error');
$success: theme-color('success');
$warning: theme-color('warning');
$info: theme-color('info');

.gst-notification-container {
    position: fixed;
    top: 20px;
    right: 20px;
    font-family: 'Roboto', sans-serif;
    z-index: 5001;
}

.gst-notification-container-mobile {
    top: unset;
    left: 50%;
    right: unset;
    bottom: 20px;
    z-index: 5001;
    transform: translateX(-50%);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.35s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>
